import MaterialListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';

class ListItem extends Component {

  render() {
    const { classes } = this.props;

    return (
      /*eslint-disable */
      <MaterialListItem
        button
        style={this.props.style}
        classes={{ selected: classes.selected, root: classes.root }}
        onClick={this.props.onClick}
        selected={this.props.selected}
        disabled={this.props.disabled}
      >
        {this.props.leftIcon
        ? <ListItemIcon> {this.props.leftIcon}</ListItemIcon>
        : null}

        <ListItemText
        //   disableTypography
        //   style={{ fontFamily: 'Montserrat, sans-serif', fontSize: 12 }}
          primary={this.props.primaryText}
          secondary={this.props.secondaryText}
          classes={{ primary: classes.primary, secondary: classes.secondary }}
        />
        {this.props.rightIconButton
        ? <ListItemIcon style={{ float: 'right', marginRight: 0, paddingLeft: 0 }}> {this.props.rightIconButton}</ListItemIcon>
        : null}
      </MaterialListItem>
      /*eslint-enable */
    );
  }
}

ListItem.propTypes = {
  onClick: PropTypes.func,
  style: PropTypes.object,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  primaryText: PropTypes.string,
  secondaryText: PropTypes.any,
  classes: PropTypes.object,
  leftIcon: PropTypes.any,
  rightIconButton: PropTypes.any,
};

ListItem.defaultProps = {
  onClick: () => {},
  selected: false,
  disabled: false,
  primaryText: '',
  secondaryText: '',
  classes: {},
  leftIcon: null,
  style: null,
  rightIconButton: null,
};

const styles = theme => ({
  root: {
    minWidth: 200,
  },
  selected: {
    color: `${theme.palette.primary.main} !important`,
    fontWeight: 'bold !important',
    backgroundColor: 'transparent !important',
    // backgroundColor: `${theme.palette.primary.main} !important`,
    // color: 'white',
  },
  primary: {
    fontSize: 16,
    color: 'black',
  },
  secondary: {
    fontSize: 14,
  },
})
 ;


export default withStyles(styles)(ListItem);




// WEBPACK FOOTER //
// ./src/app/components/list/list-item.js